import {
  Component,
  EventEmitter,
  Output,
  Input,
  OnInit,
  OnDestroy
} from '@angular/core';
import { BhutilProvider } from '../../providers/bhutil/bhutil';
import { FlavorProviderAnalysis } from '../../providers/flavor/flavor-analysis';
import { Flavor } from '../../providers/flavor/flavor';
import { AppEventService } from '../../app/app-events';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { IonRange, IonGrid, IonRow, IonCol, IonItem } from '@ionic/angular';
import { BaseFlavors } from '../../models/models';

/**
 * Generated class for the FlavorSliderAnalysisComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'flavor-slider-analysis',
  templateUrl: 'flavor-slider-analysis.html',
  styleUrls: ['./flavor-slider.scss'],
  standalone: false,
  imports: [
     IonicModule,
  //   CommonModule,
  //   FormsModule,
  //   TranslateModule
  ]
})
export class FlavorSliderAnalysisComponent implements OnInit, OnDestroy {

  @Input() baseFlavors!: BaseFlavors;
  @Output() baseFlavorsChange = new EventEmitter<BaseFlavors>();

  // Helper to handle slider moves
  updateStat(property: keyof BaseFlavors, value: number) {
    // 1. Create a COPY of the object with the new value
    // This ensures Angular detects the change for the Spider chart
    const newProfile = { 
      ...this.baseFlavors, 
      [property]: value 
    };

    this.flavor.setIntValue(property, value);

    // 2. Emit the NEW object up to the parent
    this.baseFlavorsChange.emit(newProfile);
  }


  @Output() notify: EventEmitter<any> = new EventEmitter<any>();

  private setShouldupdateSubscription: any;
  private resetSliderSubscription: any;
  private updateSlidersSubscription: any;
  private removeAllSearchSubscription: any;

  flavor: Flavor;

  shouldUpdate: boolean = false;
  shouldUpdateCount: number = 0;

  constructor(private events: AppEventService, private bhutil: BhutilProvider, private flavorProvider: FlavorProviderAnalysis) {
    this.initFlavor();
  }

  private initFlavor() {
    this.flavor = this.flavorProvider.getFlavor();
  }

  subscribeEvents() {

    this.setShouldupdateSubscription = (shouldUpdate: boolean) => {
      console.log(this);
      console.log("[flavor-slider-analysis] setting shouldUpdate value to " + shouldUpdate);
      this.shouldUpdate = shouldUpdate;
      this.shouldUpdateCount = 0;
    };
    this.events.subscribe("set:shouldupdate", this.setShouldupdateSubscription);

    this.resetSliderSubscription = (key: string) => {
      console.log("[flavor-slider-analysis] SUB reset:slider - resetting slider value for key " + key);

      this.flavor.reset(key);
    };
    this.events.subscribe("reset:slider", this.resetSliderSubscription);

    this.updateSlidersSubscription = (values: any) => {

      console.log("[flavor-slider-analysis] SUB update:sliders => with value shouldUpdate " + values.update);
      console.dir(values);

      this.shouldUpdate = values.update;
      this.shouldUpdateCount = 0;

      this.flavor.setIntValue("sweet", values.sweet);
      this.flavor.setIntValue("sour", values.sour);
      this.flavor.setIntValue("bitter", values.bitter);
      this.flavor.setIntValue("hoppy", values.hoppy);
      this.flavor.setIntValue("fruity", values.fruity);
      this.flavor.setIntValue("malty", values.malty);

    };
    this.events.subscribe("update:sliders", this.updateSlidersSubscription);

    this.removeAllSearchSubscription = (value: any) => {

      //debugger;

      //reset all sliders!

      this.shouldUpdate = false;
      this.shouldUpdateCount = 0;

      this.flavor.setIntValue("sweet", -1);
      this.flavor.setIntValue("sour", -1);
      this.flavor.setIntValue("bitter", -1);
      this.flavor.setIntValue("hoppy", -1);
      this.flavor.setIntValue("fruity", -1);
      this.flavor.setIntValue("malty", -1);

    };
    this.events.subscribe("remove:allsearch", this.removeAllSearchSubscription);
  }

  ngOnInit() {
    console.log("[flavor-slider-analysis] - ngOnInit");

    this.initFlavor();

    this.subscribeEvents();

    // force update of search characteristics if at least one is not -1
    // parameter callServer steers if the search request is sent to the backend
    let callServerMalty: Boolean = (this.flavor.maltyIntValue.valueOf() >= 0);
    let callServerFruity: Boolean = !callServerMalty && (this.flavor.fruityIntValue.valueOf() >= 0);
    let callServerHoppy: Boolean = !callServerFruity && !callServerMalty && (this.flavor.hoppyIntValue.valueOf() >= 0);
    let callServerBitter: Boolean = !callServerHoppy && !callServerFruity && !callServerMalty && (this.flavor.bitterIntValue.valueOf() >= 0);
    let callServerSour: Boolean = !callServerBitter && !callServerHoppy && !callServerFruity && !callServerMalty && (this.flavor.sourIntValue.valueOf() >= 0);
    let callServerSweet: Boolean = !callServerSour && !callServerBitter && !callServerHoppy && !callServerFruity && !callServerMalty && (this.flavor.sweetIntValue.valueOf() >= 0);

    if (this.flavor.sweetIntValue.valueOf() >= 0) {
      this.onFlavorChange("sweet", { detail: { value: this.flavor.sweetIntValue }}, callServerSweet);
    }
    if (this.flavor.sourIntValue.valueOf() >= 0) {
      this.onFlavorChange("sour", { detail: { value: this.flavor.sourIntValue }}, callServerSour);
    }
    if (this.flavor.bitterIntValue.valueOf() >= 0) {
      this.onFlavorChange("bitter", { detail: { value: this.flavor.bitterIntValue }}, callServerBitter);
    }
    if (this.flavor.hoppyIntValue.valueOf() >= 0) {
      this.onFlavorChange("hoppy", { detail: { value: this.flavor.hoppyIntValue }}, callServerHoppy);
    }
    if (this.flavor.fruityIntValue.valueOf() >= 0) {
      this.onFlavorChange("fruity", { detail: { value: this.flavor.fruityIntValue }}, callServerFruity);
    }
    if (this.flavor.maltyIntValue.valueOf() >= 0) {
      this.onFlavorChange("malty", { detail: { value: this.flavor.maltyIntValue }}, callServerMalty);
    }
  }

  ngOnDestroy() {
    console.log("[flavor-slider-analysis] - ngOnDestroy");
    this.events.unsubscribe("set:shouldupdate", this.setShouldupdateSubscription);
    this.events.unsubscribe("reset:slider", this.resetSliderSubscription);
    this.events.unsubscribe("update:sliders", this.updateSlidersSubscription);
    this.events.unsubscribe("remove:allsearch", this.removeAllSearchSubscription);
  }

  onSweetChange(event: any) {
    this.onFlavorChange("sweet", event, true);
  }

  onSourChange(event: any) {
    this.onFlavorChange("sour", event, true);
  }

  onBitterChange(event: any) {
    this.onFlavorChange("bitter", event, true);
  }

  onHoppyChange(event: any) {
    this.onFlavorChange("hoppy", event, true);
  }

  onFruityChange(event: any) {
    this.onFlavorChange("fruity", event, true);
  }

  onMaltyChange(event: any) {
    this.onFlavorChange("malty", event, true);
  }

  onFlavorChange(flavorName: string, event: any, callServer: Boolean) {
    let eventFlavorIntValue: Number = event.detail.value;

    if (this.flavor)
    console.log("[flavor-slider-analysis] " + flavorName + " value is now " + this.bhutil.stringify(eventFlavorIntValue));
    this.flavor.setIntValue(flavorName, eventFlavorIntValue);

    let e: any = {
      value: eventFlavorIntValue,
      type: flavorName,
      callServer: callServer
    }

    if (this.shouldUpdate) {
      console.log("[flavor-slider-analysis] on " + flavorName + " Change - shouldUpdate");
      this.notify.emit(e);
    }
    else {
      console.log("[flavor-slider-analysis] on " + flavorName + " Change, should not update! - count " + this.shouldUpdateCount);
      this.shouldUpdateCount++;
      if (this.shouldUpdateCount == 6) {
        console.log("[flavor-slider-analysis] on " + flavorName + " Change, now we should update again!");
        this.shouldUpdateCount = 0;
        this.shouldUpdate = true;
      }
    }
  }
}
